import { render } from "./title.vue?vue&type=template&id=2a065bb0"
import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import "./title.vue?vue&type=style&index=0&id=2a065bb0&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/text/title.vue'],['render',render],['__file',"title.vue"]])

export default __exports__